export default "/_next/static/images/cfaLogo-8b4c3d1835ee07baf8f2ed388b71c47f.svg";